import { initialState, TDisclosureMethods, TDisclosureStore } from "./disclosure.state";
import { disclosureReducer } from "./disclosure.reducer";

// ✅ Reusable store methods
export const createDisclosureActions = (
    set: any,
    get: () => TDisclosureStore
): Pick<TDisclosureStore, TDisclosureMethods> => ({
    dispatch: action => set((state: TDisclosureStore) => disclosureReducer(state, action)),

    getDisclosureByProperty: (property, value) => {
        return get().disclosures.find(item => item[property] === value);
    },

    getDisclosureIDs: () => {
        return get().disclosures.map(item => item.exploreId) as number[];
    },

    getDisclosureName: (id: number) => {
        return get().disclosures.find(item => item.exploreId === id)?.label ?? null;
    },

    reset: () => {
        set(initialState);
    },
});
